import { LotteryCountdown } from "./lottery-countdown";
import { LotteryCountdownConfig } from "./lottery-countdown-config";

export class LotteryCountdownLabel extends LotteryCountdown {
    public odometers: any;
    public labels: Array<HTMLElement>;

    constructor(parentEl) {
        let config: LotteryCountdownConfig = {
            days: false,
            hours: false,
            minutes: false,
            seconds: false,
        };

        if (parentEl.hasAttribute("data-units")) {
            config = Object.assign(
                {},
                config,
                ...parentEl.dataset.units.split(",").map((x) => {
                    return { [x.trim()]: true };
                })
            );
        }

        const pattern = parentEl.dataset.pattern ?? null;

        super(config, null, pattern);
        this.odometers = [...parentEl.querySelectorAll(".countdown-timer, .lottery-hero__countdown-value")];
        this.labels = [...parentEl.querySelectorAll(".countdown-unit, .lottery-hero__countdown-unit")];
    }

    DomRender() {
        const getTotalHours = this.units.indexOf("days") < 0;

        this.units.forEach((unit, i) => {
            const unitText = this.getUnitText(unit, getTotalHours);
            this.odometers[i].innerText = unitText;
            this.labels[i].innerText = this.localizeLabel(unit, unitText);
        });
    }
}
